import React from "react";
import { Link } from "react-router-dom";

const EmpoweringEngagingLearning = (props) => {
  return (
    <>
      <section className="eel_sec">
        <div className="container">
          <div className="eel_sec_item">
            <div>
              <img src="/assets/vimages/Group1828.png" />
            </div>
            <div className="eel_sec_item_content">
              <h2>Empowering Young Minds with Engaging Learning</h2>
              <p>
                Prime Minister Narendra Modi’s book ‘Exam Warriors’ promotes
                learning as an enjoyable, fulfilling journey. The interactive
                Exam Warriors module on the NaMo App brings the book’s key
                mantras to life through engaging visuals and activities.
                Designed for students, parents, and teachers, it offers
                practical ways to absorb valuable concepts.
              </p>
              <a
                href="https://amzn.in/d/9quv2zw"
                target="_blank"
                className="viewreels_link2"
              >
                Buy Now
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EmpoweringEngagingLearning;
